<template>
  <div class="container" v-if="getLocationPhone">
    <div class="row">
      <div class="message-help">
        <h3>{{ $t('Problems?') }}</h3>
        <div class="flex mb20">
          <template>
            <span class="material-icons">
              phone_callback
            </span>
            <span class="number-phone">
              <a :href="'tel:' + getLocationPhone"
                 v-mask="{
                   mask: '+38(999)-999-9999',
                   showMaskOnHover: false,
                   autoUnmask: true
                 }"
              >
                {{ getLocationPhone }}
              </a>
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script async>
import { mapActions, mapGetters } from 'vuex';
const BounceLoader = () => import(/* webpackChunkName: "vsf-bounce-loader" */ 'theme/components/theme/blocks/Home/Preloaders/BounceLoader');

export default {
  name: 'HelpProblems',
  components: {
    BounceLoader
  },
  props: {
    order: {
      type: [Object, null],
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      locationsNow: 'locations/getActiveLocation'
    }),
    getLocationPhone () {
      if (!this.locationsNow || !this.locationsNow.phone_for_checkout) {
        return false
      }
      return this.locationsNow.phone_for_checkout.replace('+38', '')
    }
  },
  methods: {
    ...mapActions({
      loadLocations: 'locations/loadLocations',
      setLocation: 'locations/setCurrentLocation'
    })
  },
  async mounted () {
    if (!this.locationsNow && this.order) {
      await this.loadLocations().then(() => {
        this.setLocation({ code: this.order.location_code });
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.message-help{
  width: 100%;
  margin: 0 auto;
  h3{
    text-align: center;
    font-size: 21px;
    font-weight:500;
  }
  .flex{
    font-size: 21px;
    color: #11bb2e;
    justify-content: center;
    .number-phone{
      text-decoration: none;
      a {
        margin-left: 4px;
        color: #11bb2e;
        -webkit-transition: .3s;
        -moz-transition: .3s;
        -ms-transition: .3s;
        -o-transition: .3s;
        transition: .3s;
        text-decoration: none;
        &:hover{
          text-decoration: underline;
        }
        &:hover, &:after,&:not(.no-underline){
          background-color:#ffffff;
        }
      }
    }
  }
}
</style>
